import React from 'react';
import { Chip } from '@mui/material';
import Done from '@mui/icons-material/Done';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const Ito = (props) => {
   const openDrawer = () => {
      props.setStatusDrawerOpen(true);
      props.setSpaceData(props.data);
   };

   if (props.miniChips) {
      return (
         <Chip
            size="small"
            sx={props.styles}
            clickable={props.clickable}
            label={<Done />}
            color="primary"
            variant={props.bookings ? 'filled' : 'outlined'}
         />
      );
   } else {
      if (props.clickable) {
         return (
            <Chip
               size="medium"
               sx={{
                  '& .MuiChip-label': {
                     pl: 1,
                  },
               }}
               clickable={props.clickable}
               label={<Done sx={{ mt: 0.5 }} />}
               color="primary"
               deleteIcon={<MoreVertIcon />}
               variant={props.bookings ? 'filled' : 'outlined'}
               onDelete={() => openDrawer()}
            />
         );
      } else {
         return (
            <Chip
               size="medium"
               clickable={props.clickable}
               label={<Done sx={{ mt: 0.5 }} />}
               color="primary"
               variant={'filled'}
            />
         );
      }
   }
};
export default Ito;
